import { useState } from "react";
import { ChevronDown, Sparkles } from "lucide-react";
import { useLang } from "@/context/LangContext";

function initials(name = "") {
  return name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

export default function MessageBubble({ msg }) {
  const [showOriginal, setShowOriginal] = useState(false);
  const { t, lang, roleLabel } = useLang();
  const mine = msg.is_mine;

  return (
    <div className={`flex gap-3 ${mine ? "flex-row-reverse" : ""}`} data-testid="message-item">
      <div className="w-9 h-9 rounded-md bg-primary/10 text-primary flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">
        {initials(msg.sender_name)}
      </div>
      <div className={`max-w-[70%] ${mine ? "items-end" : "items-start"} flex flex-col`}>
        <div className={`flex items-center gap-2 mb-1 ${mine ? "flex-row-reverse" : ""}`}>
          <span className="text-sm font-semibold">{msg.sender_name}</span>
          <span className="text-[10px] uppercase tracking-wider text-muted-foreground border border-border rounded px-1.5 py-0.5">{roleLabel(msg.sender_role)}</span>
          <span className="text-[11px] text-muted-foreground">
            {new Date(msg.created_at).toLocaleTimeString(lang === "en" ? "en-US" : "tr-TR", { hour: "2-digit", minute: "2-digit" })}
          </span>
        </div>

        <div className={`rounded-lg px-4 py-2.5 border ${mine ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border"}`}>
          <p className="text-sm leading-relaxed whitespace-pre-wrap">{msg.adapted_text}</p>
        </div>

        {msg.is_adapted && (
          <div className={`mt-1 ${mine ? "text-right" : ""}`}>
            <button
              onClick={() => setShowOriginal((v) => !v)}
              className="inline-flex items-center gap-1 text-[11px] text-muted-foreground hover:text-primary transition-colors"
              data-testid="toggle-original-btn"
            >
              <Sparkles className="w-3 h-3" />
              {showOriginal ? t("mb.showAdapted") : t("mb.showOriginal")}
              <ChevronDown className={`w-3 h-3 transition-transform ${showOriginal ? "rotate-180" : ""}`} />
            </button>
            {showOriginal && (
              <div className="mt-1 rounded-md border border-dashed border-border bg-muted/50 px-3 py-2 text-sm text-muted-foreground text-left" data-testid="original-text">
                {msg.original_text}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
